import { useState } from "react";


export const useDeleteScrapFinanceAccountStates = () => {
  const [scrapFinanceAccountId, setScrapFinanceAccountId] = useState("");

  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    scrapFinanceAccountId,
    setScrapFinanceAccountId,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};
